const tenant: Record<string, any> = {
    name: "productCatalog",
    path: "/productCatalog",
    component: "basic",
    meta: {
        title: "产品目录",
        i18nTitle: "Routes.productCatalog._value",
        requiresAuth: true,
        keepAlive: true,
        icon: "fluent:book-information-24-regular",
        order: 1,
        permissions: ["system:catalog:list"],
    },
    children: [
        {
            name: "productCatalog_plans",
            path: "/productCatalog/plans",
            component: "self",
            meta: {
                title: "套餐",
                i18nTitle: "Routes.productCatalog.plans",
                requiresAuth: true,
                keepAlive: true,
                icon: "ic:round-tab",
            },
        },
        {
            name: "productCatalog_features",
            path: "/productCatalog/features",
            component: "self",
            meta: {
                title: "能力",
                i18nTitle: "Routes.productCatalog.features",
                requiresAuth: true,
                keepAlive: true,
                icon: "ic:round-tab",
            },
        },
        {
            name: "productCatalog_quotas",
            path: "/productCatalog/quotas",
            component: "self",
            meta: {
                title: "配额",
                i18nTitle: "Routes.productCatalog.quotas",
                requiresAuth: true,
                keepAlive: true,
                icon: "ic:round-tab",
            },
        },
        {
            name: "productCatalog_onetimeFee",
            path: "/productCatalog/onetimeFee",
            component: "self",
            meta: {
                title: "一次性费用",
                i18nTitle: "Routes.productCatalog.onetimeFee",
                requiresAuth: true,
                keepAlive: true,
                icon: "ic:round-tab",
            },
        },
        {
            name: "productCatalog_hierarchy",
            path: "/productCatalog/hierarchy",
            component: "self",
            meta: {
                title: "层级视图",
                i18nTitle: "Routes.productCatalog.hierarchy",
                requiresAuth: true,
                keepAlive: true,
                icon: "ic:round-tab",
            },
        },
        // {
        //     name: "productCatalog_detail",
        //     path: "/product-catalog/detail",
        //     component: "self",
        //     meta: {
        //         title: "productCatalog_detail",
        //         i18nTitle: "Routes.productCatalog.detail",
        //         requiresAuth: true,
        //         keepAlive: false,
        //         icon: "ic:round-tab",
        //         hide: true,
        //     },
        // },
    ],
}

export default tenant
